import { rdxPopupOpen } from "commons/popup/store/popupR";
import { useDispatch } from "react-redux";
import { PopupType } from "../PopupType";
import { useSelectorEq } from "commons/store/common";
import type { IState } from "store/modules";
import { RatioButtonGroup } from "./calculateRatioPopup";
import { useAlert, useIConPopup } from "../popupHook";
import { ButtonState } from "commons/popup/store/absPopupVo";
import { useClosePopup } from "commons/popup/store/absPopupHook";
import { useInputText } from "commons/ui/useUihook";
import { rdxSetCalculateGridRowUpdate } from "pages/calculate/store/CalculateR";
import { useApi } from "store/modules/common";
import { apiGPartnerList, rdxResetPartnersList } from "pages/user/store/UserR";
import { useEffect } from "react";

export const useCalculateRatioPopup = (subTab: string) => {
  const dispatch = useDispatch();
  const { list } = useSelectorEq((state: IState) => ({
    list: state.calculate.contents[subTab].detailList,
  }));

  const showCalculateRatioPopup = async () => {
    dispatch(
      rdxPopupOpen({
        type: PopupType.CALCULATE_RATIO_POPUP,
        width: 400,
        isClose: true,
        data: list,
        buttonWrapper: RatioButtonGroup,
      }),
    );
  };
  return { showCalculateRatioPopup };
};

export function useGetCheckChannelList() {
  /**
   * 체크박스 리턴
   */
  const { checkbox } = useSelectorEq((state: IState) => ({
    checkbox: state.ui.checkBox !== undefined && state.ui.checkBox?.["gridAllCheckbox"],
  }));

  const checkList: string[] = [];

  if (checkbox) {
    for (const [key, value] of Object.entries(checkbox)) {
      if (value) {
        checkList.push(key);
      }
    }
  }

  return checkList;
}

function useRatioInputValue() {
  const { inputValue } = useSelectorEq((state: IState) => ({
    inputValue: state.ui.inputText !== undefined && state.ui.inputText?.["popup_ratio_input"],
  }));
  return { inputValue };
}

/**
 * 요율 일괄 적용
 * @returns
 */
export function useApplyRatioChannel() {
  const dispatch = useDispatch();
  const { close } = useClosePopup(PopupType.CALCULATE_RATIO_POPUP);
  const iconPopup = useIConPopup();
  const checkList = useGetCheckChannelList();
  const { changeValue, inputTextValue } = useInputText("popup_ratio_input");
  const alert = useAlert();

  const { inputValue } = useRatioInputValue();

  const apply = async () => {
    if (!inputTextValue) {
      alert("적용 할 요율값을 입력해주세요.");
      return;
    }
    if (inputTextValue && inputTextValue?.length > 2) {
      alert("요율은 100% 이상 입력할 수 없습니다.");
      changeValue("0");
      return;
    }
    iconPopup(
      "confirm",
      {
        iconColor: "#d057c4",
        iconType: "Check",
        title: `요율 ${Number(inputValue)}%로 일괄 적용하시겠습니까?`,
      },
      undefined,
      (bo?: ButtonState) => {
        if (bo) {
          close(ButtonState.OK);
          checkList.map(i => {
            const code = i.substring(i.indexOf("_") + 1, i.length);
            dispatch(rdxSetCalculateGridRowUpdate({ code: code, type: "ratio", value: inputValue! as string }));
          });
        }
      },
    );
  };

  return { apply };
}
